import script from "./DetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailView.vue?vue&type=script&setup=true&lang=js"

import "./DetailView.vue?vue&type=style&index=0&id=70a1ce6d&lang=css"

const __exports__ = script;

export default __exports__